import { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { createModal } from "../hooks/createModal";
import Menu from "../ui/Menu";
import Card from "../ui/Card";
import Label from "../ui/Label";
import ReportsCustomInventory from "../components/ReportsCustomInventory";
import ReportsCustomInventory2 from "../components/ReportsCustomInventory2";

export default function ReportsController(props) {

     
    const { is_modal = false, signal = {}, search = "", callback = () => { }, setController = () => { } } = props;

    const route = ROUTES.REPORTS.REPORTS;

    const [selected, setSelected] = useState("1");
    const [state, setState] = useState({ view: "reports" });

    const switchView = (_view) => {

        switch (_view) {
            case "custom_inventory_reports":
                window.bm_state.value = ROUTES.REPORTS.CUSTOM_INVENTORY;
                break;
            default:
                window.bm_state.value = ROUTES.REPORTS.REPORTS;
                break;
        }
        setState({ ...state, view: _view });
    }

    const menu = [
        { text: "Custom Inventory Reports", key: KBD.Digit1, option: "custom_inventory_reports", action: () => switchView("custom_inventory_reports") },
        // { text: "Custom Inventory Reports Single Layout", key: KBD.Digit2, option: "custom_inventory_reports2", action: () => switchView("custom_inventory_reports2") },
        { text: "Inventory Reports", key: KBD.Digit2, option: "2", action: () => alert("a") },
        { text: "Sales Reports", key: KBD.Digit3, option: "3", action: () => alert("a") },
        { text: "Orders Reports", key: KBD.Digit4, option: "4", action: () => alert("a") },
        { text: "Supplier Reports", key: KBD.Digit5, option: "5", action: () => alert("a") },
        { text: "Gift Cards", key: KBD.Digit6, option: "6", action: () => alert("a") },
        { text: "Multi-store documents", key: KBD.Digit7, option: "7", action: () => alert("a") },
        { text: "files in \\Reports directory", key: KBD.Digit8, option: "8", action: () => alert("a") },
    ]

    const nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { key: KBD.ENTER, action: () => { switchView(selected) } },
    ]

    useEffect(() => {
        const cleanup = listen(route, nav);
        return cleanup;
    }, [nav, selected]);

    useEffect(() => { window.bm_state.value = route }, []);

    const drawMenu = () => {
        return (
            <div style={{ height: "calc(100vh - 74px)", minHeight: "600px", }} className="controller">
                <div style={{ "padding": "10px 15px" }}>
                    <Card style={{ "width": "800px" }} secondary header={<Label style={{ "textAlign": "left" }}>Report Areas</Label>}>
                        <Menu callback={(e) => switchView(e?.option)} bordered allow_keys keyName="option" show_keys setSelected={setSelected} selected={selected} menu={menu} route={route} />
                    </Card>
                </div>
            </div>
        )
    }


    const draw = () => {

        switch (state.view) {
            case "custom_inventory_reports":
                return <ReportsCustomInventory setController={setController} signal={signal} route={ROUTES.REPORTS.CUSTOM_INVENTORY} switchView={switchView} />
                break;
            case "custom_inventory_reports2":
                return <ReportsCustomInventory2 signal={signal} route={ROUTES.REPORTS.CUSTOM_INVENTORY} switchView={switchView} />
                break;
            default:
                return drawMenu();
        }

    }

    return draw();

}


